import { toast } from '@/helpers/toast/toast.helper'
import { zApiMultiService } from '@/services/api'
import { AxiosResponse } from 'axios'
import { put } from 'redux-saga/effects'
import { unPromoteAdminGroupAction } from '../../handles'
import { unpromoteAdmin } from '../_http/groups'

export function* unPromoteAdminGroupSaga(action: ReturnType<typeof unPromoteAdminGroupAction.request>) {
  const { activeChat, phones, campaign, callBack } = action.payload
  try {
    const url = `/instances/campanhaId/${campaign.id}/token/${campaign.token}/remove-admin`
    const unPromoteAdminGroupResponse: AxiosResponse = yield zApiMultiService.post(url, {
      groupId: activeChat.phone,
      phones
    })

    if (unPromoteAdminGroupResponse.data?.value) {
      const { participants } = activeChat
      const findedParticipant = participants.find(participant => participant.phone === phones[0])
      if (findedParticipant) {
        findedParticipant.isAdmin = false
      }
      yield unpromoteAdmin(activeChat.id, phones[0], activeChat.ownerId)
      toast({ type: 'success', message: `Contato sem privilegios de administrador` })
      yield put(unPromoteAdminGroupAction.success({ updatedChatData: { participants } }))
      callBack?.()
    } else {
      toast({ type: 'error', message: 'Não foi possível remover privilegios de administrador, tente novamente' })
      yield put(unPromoteAdminGroupAction.failure(null))
    }
  } catch (error) {
    toast({ type: 'error', message: 'Erro ao remover privilegios de administrador do contato' })
    console.log({ unPromoteAdminGroupSagaError: error })
    yield put(unPromoteAdminGroupAction.failure(error))
  }
}
